// src/components/LoadingSpinner.jsx
import React from "react";
import { CircularProgress, Box } from "@mui/material";

export default function LoadingSpinner() {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        bgcolor: "#f8f9fb",
        color: "#555",
      }}
    >
      <CircularProgress size={40} />
    </Box>
  );
}
